import styled from 'styled-components';
import { CFBaseModalContentStyles } from '@connectrn/ds-ui-base';
export const CFModalContentElements = {
    Body: styled.div `
    ${CFBaseModalContentStyles.Body}
    ${CFBaseModalContentStyles.BodyWeb}
  `,
    Footer: styled.div `
    ${CFBaseModalContentStyles.Footer}
    ${CFBaseModalContentStyles.FooterWeb}
  `,
    Header: styled.div `
    ${CFBaseModalContentStyles.Header}
    ${CFBaseModalContentStyles.HeaderWeb}
  `,
    Root: styled.div `
    ${CFBaseModalContentStyles.Root}
    ${CFBaseModalContentStyles.RootWeb}
  `,
};
